import { Fragment } from 'react';
import { MoveRight } from 'lucide-react';
import { motion } from 'framer-motion';
import { EASE } from './motion';

/* Gold line-art glyphs for the five service areas */
const GLYPHS = {
  'healthcare-revenue': (
    <>
      <motion.path d="M6 34h10l5-14 9 26 6-13h22" fill="none" strokeWidth="2" />
      <motion.path d="M46 10h12v12" fill="none" strokeWidth="2" />
    </>
  ),
  'employee-benefits': (
    <>
      <motion.path d="M32 6l19 7v13c0 14-8.5 24.5-19 31C21.5 50.5 13 40 13 26V13z" fill="none" strokeWidth="2" />
      <motion.path d="M24 30l6 6 11-12" fill="none" strokeWidth="2" />
    </>
  ),
  'technology-costs': (
    <>
      <motion.rect x="17" y="17" width="30" height="30" rx="4" fill="none" strokeWidth="2" />
      <motion.path d="M26 27h12v12H26zM32 6v11M32 47v11M6 32h11M47 32h11M20 8v9M44 8v9" fill="none" strokeWidth="2" />
    </>
  ),
  'shipping-costs': (
    <>
      <motion.path d="M32 8l20 9v30l-20 9-20-9V17z" fill="none" strokeWidth="2" />
      <motion.path d="M12 17l20 9 20-9M32 26v30" fill="none" strokeWidth="2" />
    </>
  ),
  'ai-marketing': (
    <>
      <motion.path d="M10 54V38M24 54V28M38 54V20M52 54V10" fill="none" strokeWidth="2" />
      <motion.path d="M8 30C22 30 40 20 54 8" fill="none" strokeWidth="2" />
      <motion.path d="M44 8h10v10" fill="none" strokeWidth="2" />
    </>
  ),
};

export function ServiceGlyph({ name, className = '', testid }) {
  return (
    <svg
      viewBox="0 0 64 64"
      className={className}
      data-testid={testid}
      role="img"
      aria-hidden="true"
      stroke="url(#glyph-gold)"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <defs>
        <linearGradient id="glyph-gold" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#B28B43" />
          <stop offset="0.55" stopColor="#F3E5AB" />
          <stop offset="1" stopColor="#D4AF37" />
        </linearGradient>
      </defs>
      {GLYPHS[name]}
    </svg>
  );
}

/* Animated gold line-art flow: Current spend → Requirements → Options → Implementation */
export default function FlowDiagram({ steps, testid = 'flow-diagram' }) {
  return (
    <div
      className="flow"
      data-testid={testid}
      role="img"
      aria-label={steps.map((s) => s.label).join(' to ')}
    >
      {steps.map((s, i) => (
        <Fragment key={s.label}>
          <motion.div
            className="flow__node"
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.6, delay: i * 0.14, ease: EASE }}
          >
            <span className="flow__step-n">{s.n}</span>
            <span className="flow__label block">{s.label}</span>
          </motion.div>
          {i < steps.length - 1 && (
            <div className="flow__arrow" aria-hidden="true">
              <div className="flow__dash flex-1" />
              <MoveRight size={16} className="flex-none -ml-1" />
            </div>
          )}
        </Fragment>
      ))}
    </div>
  );
}
